export type StepperProps = {
  components: {
    Footer: React.ComponentType;
  };
  label: string;
  id: string | number;
  parentId?: string | number;
  children: React.ReactNode;
};

export enum RegisterTerminalModalType {
  Stripe = 'stripe',
  Justifi = 'justifi',
}
